import axios from 'axios';

const instance = axios.create({
    baseURL: '/api',
    //baseURL: 'http://localhost:3000/api',
    timeout: 5000
});

instance.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token && token != 'undefined') {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Токен живёт 12 часов. Когда он истёк, сервер отвечает 401, и раньше страницы
// просто оставались пустыми — теперь возвращаем на вход
instance.interceptors.response.use(
    (response) => response,
    (error) => {
        const onAuthPage = window.location.pathname.startsWith('/auth');
        if (error.response?.status === 401 && !onAuthPage) {
            localStorage.removeItem('token');
            window.location.assign('/auth?expired=1');
        }
        return Promise.reject(error);
    }
);

export default instance;
